import './Ordinal.scss';

interface OrdinalProps {
  /** The 1-based position shown in the badge. */
  readonly value: number;
}

/**
 * A small square badge showing a 1-based position — the numeric marker on a
 * card header (e.g. "Recurrence 1", the "2" on the second matcher). Purely
 * presentational; the accent colour is a theme decision.
 */
export const Ordinal = ({ value }: OrdinalProps) => <span className="ordinal">{value}</span>;
